import { Button, message, Radio, Tooltip } from "antd";
import React, { forwardRef, useImperativeHandle, useState } from "react";

import {
	SaveOutlined,
	ThunderboltOutlined,
} from "@ant-design/icons";

import PropTypes from "prop-types";

export const SaveOptions = forwardRef(({
	loading = false, 
	sendingChanges = false,
	disableSave = false,
	onSendChanges = () => {},
}, ref) => {
	const [automaticMode, setAutomaticMode] = useState(true);

	const executeIfIsValid = (actionToRun = () => {}) => {
		if (automaticMode && !sendingChanges) {
			actionToRun();
		}
	};

	useImperativeHandle(ref, () => ({
		methodToRun: (funcToRun) => executeIfIsValid(funcToRun),
	}));

	return (
		<>
			<Radio.Group
				value={automaticMode}
				onChange={(e) => {
					const isActivated = e.target.value;
					
					if(isActivated){
						message.info("Activaste el modo de Guardado Automático");
					}
					
					setAutomaticMode(isActivated);
				}}
				style={{ marginRight: "5px" }}
			>
				<Tooltip title="Guardado Manual">
					<Radio.Button loading={loading} value={false}><SaveOutlined /></Radio.Button>							
				</Tooltip>
				<Tooltip title="Guardado Automático">
					<Radio.Button loading={loading} value={true}><ThunderboltOutlined /></Radio.Button>							
				</Tooltip>
			</Radio.Group>	

			{!automaticMode && 
				<Button
					type="primary"
					onClick={onSendChanges}
					disabled={disableSave}
					loading={sendingChanges}
				>
					Guardar Cambios
				</Button>	
			}		
		</>
	);
});

SaveOptions.displayName = "SaveOptions";

SaveOptions.propTypes = {
	loading: PropTypes.bool,
	sendingChanges: PropTypes.bool,
	disableSave: PropTypes.bool,
	onSendChanges: PropTypes.func,
};
